/**
 * Poster API — server-rendered social posters from a published end-product.
 *
 * Calls mms-creator POST /api/customer/poster. The endpoint pulls the product's
 * white base + designed image + title + price, renders a complete poster (baked
 * real-font text via satori + resvg), stores it in R2 and returns a CDN url.
 * why -> bao 2026-06-26 (server endpoint outputs the full poster).
 */

import { apiRequest } from './index.js'
import { CONFIG } from '../core/config.js'

/**
 * Generate a poster for an end-product.
 * @param {{ endProductId: string, template?: 'hero'|'showcase', platform?: 'ig_post'|'ig_story'|'ig_square', eyebrow?: string, cta?: string }} opts
 * @returns {Promise<{ asset: { public_url: string }, template: string, width: number, height: number }>}
 */
export async function generatePoster({ endProductId, template = 'hero', platform = 'ig_post', eyebrow, cta }) {
  const data = await apiRequest(`${CONFIG.FRONTEND_API}/api/customer/poster`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      end_product_id: endProductId,
      template,
      platform,
      ...(eyebrow ? { eyebrow } : {}),
      ...(cta ? { cta } : {}),
    }),
  })
  return data?.data
}
